// Hierarchical regions data — can be overridden by /api/v1/regions from backend
const REGIONS = [
  {
    id: 'damascus',
    name: 'دمشق',
    neighborhoods: [
      {
        id: 'damascus_old',
        name: 'دمشق القديمة',
        subAreas: ['الجورة', 'العمارة', 'باب توما', 'القيمرية', 'الحميدية', 'الحريقة', 'الأمين', 'مئذنة الشحم', 'الشاغور جواني'],
      },
      {
        id: 'saruja',
        name: 'ساروجة',
        subAreas: ['سوق ساروجة', 'العقيبة', 'العمارة البرانية', 'مسجد الأقصاب', 'القصاع', 'العدوي', 'القصور', 'فارس الخوري'],
      },
      {
        id: 'qanawat',
        name: 'القنوات',
        subAreas: ['الحجاز', 'البرامكة', 'باب الجابية', 'باب سريجة', 'السويقة', 'قبر عاتكة', 'المجتهد', 'الأنصاري'],
      },
      {
        id: 'jobar',
        name: 'جوبر',
        subAreas: ['جوبر الشرقي', 'جوبر الغربي', 'المامونية', 'الاستقلال'],
      },
      {
        id: 'midan',
        name: 'الميدان',
        subAreas: ['ميدان وسطاني', 'الزاهرة', 'الحقلة', 'الدقاق', 'القاعة', 'باب مصلى'],
      },
      {
        id: 'shaghour',
        name: 'الشاغور',
        subAreas: ['شاغور براني', 'باب شرقي', 'ابن عساكر', 'النضال', 'الوحدة', 'بلال الحبشي', 'روضة الميدان', 'الزهور'],
      },
      {
        id: 'tadamon',
        name: 'التضامن',
        subAreas: ['التضامن'],
      },
      {
        id: 'qadam',
        name: 'القدم',
        subAreas: ['السيدة عائشة', 'القدم', 'المصطفى', 'الشريباتي', 'العسالي', 'القدم الشرقي'],
      },
      {
        id: 'kafrsouseh',
        name: 'كفر سوسة',
        subAreas: ['كفرسوسة البلد', 'الإخلاص', 'الواحة', 'الفردوس', 'اللوان'],
      },
      {
        id: 'mazza',
        name: 'المزة',
        subAreas: ['الربوة', 'شيخ سعد (المزة القديمة)', 'الجلاء', 'مزة جبل', 'فيلات شرقية', 'فيلات غربية', 'مزة 86', 'مزة بساتين (خلف الرازي)'],
      },
      {
        id: 'dmar',
        name: 'دمر',
        subAreas: ['مشروع دمر', 'دمر الشرقية', 'دمر الغربية', 'العرين', 'الورود'],
      },
      {
        id: 'barzeh',
        name: 'برزة',
        subAreas: ['برزة البلد', 'مساكن برزة', 'المنارة', 'العباس', 'النزهة', 'عش الورور'],
      },
      {
        id: 'qaboun',
        name: 'القابون',
        subAreas: ['تشرين', 'القابون', 'المصانع'],
      },
      {
        id: 'rukn_aldin',
        name: 'ركن الدين',
        subAreas: ['أسد الدين', 'النقشبندي (شيخ خالد)', 'الأيوبية', 'الفيحاء'],
      },
      {
        id: 'salihiyya',
        name: 'الصالحية',
        subAreas: ['قاسيون', 'أبو جرش', 'الشيخ محي الدين', 'المدارس', 'المزرعة', 'الشهداء'],
      },
      {
        id: 'muhajireen',
        name: 'المهاجرين',
        subAreas: ['شورى', 'المصطبة', 'المرابط', 'الروضة', 'أبو رمانة', 'المالكي', 'الحبوبي'],
      },
      {
        id: 'yarmouk',
        name: 'اليرموك',
        subAreas: ['اليرموك'],
      },
    ],
  },
  {
    id: 'rif_dimashq',
    name: 'ريف دمشق',
    neighborhoods: [
      {
        id: 'eastern_ghouta',
        name: 'الغوطة الشرقية',
        subAreas: ['دوما', 'عربين', 'حرستا', 'المليحة', 'النشابية', 'حزة', 'سقبا', 'حمورية', 'كفربطنا', 'مديرا', 'زبدين'],
      },
      {
        id: 'zabadani',
        name: 'الزبداني',
        subAreas: ['الزبداني', 'بلودان', 'سرغايا', 'مضايا'],
      },
      {
        id: 'tall',
        name: 'التل',
        subAreas: ['التل', 'منين', 'معربا', 'تلفيتا', 'برهليا', 'حريصون', 'رنكوس'],
      },
      {
        id: 'qudsaya',
        name: 'قدسيا',
        subAreas: ['جديدة الوادي', 'وادي بردى', 'جمرايا', 'الهامة', 'أشرفية الوادي'],
      },
      {
        id: 'daraya',
        name: 'داريا',
        subAreas: ['داريا', 'المعضمية', 'صحنايا', 'أشرفية صحنايا'],
      },
      {
        id: 'south_damascus',
        name: 'جنوب دمشق',
        subAreas: ['اليرموك', 'الحجر الأسود', 'العسالي', 'ببيلا', 'يلدا', 'بيت سحم', 'حجيرة', 'خربة ورد', 'سيدي مقداد', 'السيدة زينب'],
      },
    ],
  },
]

export default REGIONS
